import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const CheckIcon = ({ size = 15, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle
            cx="8"
            cy="8"
            r="7"
            stroke={props.color || "currentColor"}
            strokeWidth="1.25"
        />
        <path
            d="M5 8.5L7 10.5L11 6"
            stroke={props.color || "currentColor"}
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CheckIcon;
